import React from "react";
import PdsLogo from "../../assets/icons/pds-logo.svg?react";

// PDS brand navy. The SVG paints with `currentColor`, so this is just the
// default colour — override it via `style={{ color }}` (or an inherited MUI
// `color`) to recolour the mark, e.g. to grey it inside a disabled control.
const PDS_NAVY = "#001E64";

/**
 * Custom PDS glyph (design D2) used on the CRM toolbar icon, the review banner
 * and the quote export button — a plain SVGR wrapper so every surface renders
 * the identical mark. Navy by default; colour-overridable via `currentColor`.
 */
export function PdsIcon({
  style,
  ...props
}: React.ComponentProps<typeof PdsLogo>) {
  return (
    <PdsLogo
      width={20}
      height={20}
      style={{ color: PDS_NAVY, ...style }}
      {...props}
    />
  );
}
